var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPendingSubmission(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 20,
    viewBox: "0 0 15 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 5V2H14C14.2761 2 14.5 1.77614 14.5 1.5V0.5C14.5 0.223858 14.2761 0 14 0H1C0.723858 0 0.5 0.223858 0.5 0.5V1.5C0.5 1.77614 0.723858 2 1 2H1.5V5C1.48952 5.92514 1.90649 6.80335 2.63 7.38L5.9 10L2.63 12.62C1.90649 13.1966 1.48952 14.0749 1.5 15V18H1C0.723858 18 0.5 18.2239 0.5 18.5V19.5C0.5 19.7761 0.723858 20 1 20H14C14.2761 20 14.5 19.7761 14.5 19.5V18.5C14.5 18.2239 14.2761 18 14 18H13.5V15C13.4982 14.0889 13.0825 13.2279 12.37 12.66L9.1 10L12.37 7.38C13.0935 6.80335 13.5105 5.92514 13.5 5ZM11.12 14.14C11.3819 14.3455 11.5244 14.6679 11.5 15H3.5C3.5014 14.6957 3.64126 14.4086 3.88 14.22L7.5 11.28L11.12 14.14ZM11.12 5.78C11.3587 5.59135 11.4986 5.30427 11.5 5V2H3.5V5C3.48888 5.31825 3.63 5.62276 3.88 5.82L5.35 7H9.65L11.12 5.78Z",
    fill: "#FC5A5A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingSubmission);
export default __webpack_public_path__ + "static/media/PendingSubmission.04904ba3e8d07a1e1d9c76a2b3a3e7db.svg";
export { ForwardRef as ReactComponent };